import jwtDecode from "jwt-decode";
import isEmpty from "lodash/isEmpty";

import { getLocal, clearLocal } from "@/helpers/localStore";
import { LOCAL_STORAGE, HTTP_STATUS } from "@/config/constants";
import { postBroadcastChannelMessage } from "./broadcastChannelHelper";

import { logger } from "@/helpers/loggerHelper";

type AuthTokenPayload = {
  exp?: number;
  name?: string;
  role_id?: number | string;
};

export const isUserLoggedIn = (token = "") => {
  // const isLoginRedirect = isLoginRedirectPath();
  // const searchToken = getAuthTokenFromSearchParams();

  // let authToken = isLoginRedirect
  //   ? searchToken
  //   : token || getLocal(LOCAL_STORAGE.TOKEN_NAME);

  const authToken = String(token || getLocal(LOCAL_STORAGE.TOKEN_NAME) || "");
  // if (getLocal("selectedBrand")) {
  //   localStorage.clear();
  //   return false;
  // }
  if (!isEmpty(getLocal(LOCAL_STORAGE.TOKEN_NAME))) {
    try {
      // clearLocal();
      const decoded = jwtDecode<AuthTokenPayload>(authToken);

      // check is token expired if yes clear local
      if (decoded.exp < Date.now() / 1000) {
        clearLocal();
        return false;
      }

      // checking is token has this keys if not clear local
      if (!decoded.role_id || !decoded.name || !decoded.exp) {
        clearLocal();
        return false;
      }
    } catch (err) {
      logger.error("JWT decode error in isUserLoggedIn", err);
      clearLocal();
      return false;
    }

    return true;
  } else {
    return false;
  }
};

export const reloadOtherTabs = () => {
  postBroadcastChannelMessage("reload");
};

/**
 * @method isUnauthorized
 * @description checks if error is 401
 * @param {object} error
 * @returns {boolean}
 */
export const isUnauthorized = (error) => {
  return error?.response?.status === HTTP_STATUS.UNAUTHORIZED;
};

let isLoggingOut = false;

/**
 * @method performLogout
 * @description dispatches logout action and clears state
 */
export const performLogout = () => {
  if (isLoggingOut || typeof window === "undefined") return;
  isLoggingOut = true;
  import("@/features/auth/store/logoutAction")
    .then(({ logoutAction }) =>
      import("@/config/store").then(({ default: store }) => {
        store.dispatch(logoutAction());
      })
    )
    .catch(() => {
      clearLocal();
      reloadOtherTabs();
      window.location.href = "/";
    })
    .finally(() => {
      isLoggingOut = false;
    });
};

export const isLogoutInProgress = () => isLoggingOut;

// function isLoginRedirectPath() {
//   const pathname = window.location.pathname;
//   return pathname === "/login-redirect";
// }

// function getAuthTokenFromSearchParams() {
//   const queryParams = new URLSearchParams(window.location.search);
//   return queryParams.get("token");
// }
